export const API_EXTERNAL_ENDPOINT = 'provinces/:provinceSlug/villages'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/provinces/villages'
